import { render, staticRenderFns } from "./DescargarListadoPlazos.vue?vue&type=template&id=b2270764"
import script from "./DescargarListadoPlazos.vue?vue&type=script&lang=js"
export * from "./DescargarListadoPlazos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports